// extracted by mini-css-extract-plugin
module.exports = {"redirectPage":"RedirectPage_redirectPage__Tjk0o","loader":"RedirectPage_loader__aNnh3"};